import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77f21cef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "search_form" }
const _hoisted_6 = { class: "sns" }
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = { class: "search_input" }
const _hoisted_9 = { class: "search_keyword" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "search_type" }, "Keyword", -1))
const _hoisted_11 = { class: "search_img" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "search_type" }, "Image", -1))
const _hoisted_13 = { class: "file_wrap" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "search_btn" }
const _hoisted_17 = {
  key: 0,
  class: "modal_bg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sns.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("li", null, [
                      _createElementVNode("img", {
                        src: !$setup.sns.selected.some((idx) => item.idx === idx) ? item.disableImg : item.activeImg,
                        alt: "",
                        onClick: ($event: any) => ($setup.selectSns(item.idx))
                      }, null, 8, _hoisted_7)
                    ]))
                  }), 256))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search.keyword) = $event)),
                    name: "searchKeyword",
                    class: "searchKeyword",
                    placeholder: "키워드를 입력하세요",
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchApi && $setup.searchApi(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, $setup.search.keyword]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["fileupload", $setup.search.file ? 'upload' : '']),
                      onDrop: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleDrop && $setup.handleDrop(...args)), ["prevent"])),
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.triggerFileInput && $setup.triggerFileInput(...args)))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass($setup.search.file ? 'upload_img' : '')
                      }, [
                        _createElementVNode("img", {
                          src: $setup.selectFile.url,
                          alt: ""
                        }, null, 8, _hoisted_14)
                      ], 2),
                      _createElementVNode("span", {
                        innerHTML: $setup.search.file ? $setup.search.file.name : '이미지를 첨부해주세요'
                      }, null, 8, _hoisted_15)
                    ], 34),
                    _createElementVNode("input", {
                      type: "file",
                      id: "fileInput",
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.FileUpload && $setup.FileUpload(...args))),
                      hidden: "",
                      accept: "image/*"
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.searchApi && $setup.searchApi(...args)))
                }, "검색")
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_Spinner)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}